/**
 * Carousel
 */

import $ from 'jquery';

import 'bootstrap/js/dist/carousel';

// Module dependencies
import 'protons';

// Module template
import './_carousel.twig';

// Module styles
import './_carousel.scss';

export const name = 'carousel';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {
  console.log();
}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
// eslint-disable-next-line no-unused-vars
export function enable($context) {
  $('.carousel').carousel({
    interval: 3000,
  });
  let carouselLength = $('.carousel .carousel-item').length;
  if (carouselLength == 1) {
    $('.carousel').addClass('carousel-one-element');
  }
}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};